import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import LoginForm from "../../sections/LoginForm/LoginForm";
import "./Login.css";

const SITE_KEY = "6LcI1fgrAAAAAJuOhpKjm-SGUcQkuJBgC4S2nDXn"; // reCAPTCHA v3 site key

function Login() {
  return (
    <main className="Login auth-page">
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
        <LoginForm />
      </GoogleReCaptchaProvider>
    </main>
  );
}

export default Login;
